import {
  usePagination,
  useRefinementList,
  useSearchBox,
  useMenu,
  useConfigure,
} from "react-instantsearch";

export function VirtualPagination(props) {
  usePagination(props);

  return null;
}

export function VirtualRefinementList(props) {
  useRefinementList(props);

  return null;
}

export function VirtualSearchBox(props) {
  useSearchBox(props);

  return null;
}

export function VirtualMenu(props) {
  useMenu(props);

  return null;
}

export function VirtualConfigure(props) {
  useConfigure(props);

  return null;
}
